const content = {
    booking_data_upload: {
        en: {
            data_type_description: 'Booking.com Upload',
            summary_no_video_html: '<p>This is the second part of the Booking.com data task. Please upload your Booking.com data file by following the instructions below:</p>',
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Save your booking.com file to your File Manager App (ios/android) or save to a folder on your computer (laptop/desktop).</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Unzip the file. For iOS, double-tap to unzip. For Android, tap on preview and then tap extract/zip.  On laptop/desktop, double-click to unzip.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Locate file named <b>report.html</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Tap/click on <b>Choose file</b> below — upload <b>report.html</b>.</p>`
                },
            ]
        }
    }
};

export const bookingDataTypes = {
    booking_data_upload: {
        data_type: 'booking_data_upload',
        data_type_description: 'Booking.com Data Upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/booking.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.booking_data_upload,
        }
    },
};